function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "14",
  height: "15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M11.519.009a1 1 0 011.122.86l.45 3.4a1 1 0 01-.657 1.074l-3.1 1.1a1 1 0 01-.668-1.885l1.394-.495A4.978 4.978 0 007 3C4.252 3 2 5.252 2 8s2.252 5 5 5c2.327 0 4.308-1.57 4.8-3.723.007-.031.016-.062.026-.093.11-.331.174-.747.174-1.184a1 1 0 112 0c0 .596-.082 1.213-.26 1.77C13.013 12.841 10.206 15 7 15c-3.852 0-7-3.148-7-7s3.148-7 7-7a6.97 6.97 0 013.79 1.128l-.131-.997a1 1 0 01.86-1.122z",
  fill: "#51BB7B"
})));